import type { HTMLRendererProps } from '@src/components/HTMLRenderer/HTMLRenderer.props'

export const HTMLRendererDefaults: HTMLRendererProps = {
  srcDoc: 'content',
}
